import { QueryKey } from "@tanstack/react-query";

export const strongCustomerAuthorization = {
  all: () => ["strongCustomerAuthorization"] as QueryKey,
};
